import {ActionBrick, registerBrick, ErrorFlow, Sync, File, CloudObject} from 'olympe';
import {getLogger} from '@olympeio/core';
import XLSX from 'xlsx';
import {convertExcelSheetToObjects, createMappingFromBusinessObject, validateInputs} from './dataFormatHandlers';

export default class ReadExcelFile extends ActionBrick {
    /**
     * @override
     */
    init($) {
        this.logger = getLogger('ReadExcelFile');
    }

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {File} file
     * @param {string} sheetName
     * @param {Sync} businessObject
     * @param {Map} mapping
     * @param {boolean} automaticDiscovery
     * @param {string} range
     * @param {function()} forwardEvent
     * @param {function(Array<Sync>)} setObjects
     * @param {function(*)} setErrorFlow
     */
    async update($, [file, sheetName, businessObject, mapping, automaticDiscovery, range], [forwardEvent, setObjects, setErrorFlow]) {
        try {
            // Guards
            if (!(file instanceof File)) {
                throw new Error(`The file input is supposed to be a file`);
            }
            if (sheetName && typeof sheetName !== 'string') {
                throw new Error(`The sheetName is supposed to be a string`);
            }

            validateInputs(businessObject, mapping, automaticDiscovery, range);

            if (automaticDiscovery) {
                mapping = createMappingFromBusinessObject(businessObject);
            }

            try {
                const data = await file.getContentAsBinary();

                const workbook = XLSX.read(data, {type: 'array', cellDates: true});

                const sheet_name = sheetName && sheetName.trim() !== '' ? sheetName : workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheet_name];

                // Wrong inputs
                if (worksheet === undefined) {
                    setErrorFlow(ErrorFlow.create(`The specified sheet (${sheetName}) doesn't exist. (First sheet name : "${workbook.SheetNames[0]}")`, 0));
                    return;
                }

                const objects = await convertExcelSheetToObjects(worksheet, range, mapping, businessObject);

                setObjects(objects.map((tag) => CloudObject.get(tag)));
                forwardEvent();
            } catch (error) {
                this.logger.error(error);
                setErrorFlow(ErrorFlow.create(error, 1));
            }
        } catch (error) {
            this.logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error, 2));
        }
    }
}

registerBrick('017c2b9ee15ae5c2af41', ReadExcelFile);
